// extracted by mini-css-extract-plugin
module.exports = {"full-width":"style_full-width__1yQn1BERXkUSpuQrXISktc","fullWidth":"style_full-width__1yQn1BERXkUSpuQrXISktc","container":"style_container__2m6hOw1PlfmMxv50ywklxN"};